import { ApolloCache } from '@apollo/client'

/**
 * Propagation of global custom audience questions is automatic on the backend:
 * toggling a question global (or changing the base market) copies it into — or
 * removes it from — the OTHER markets. Those markets' queries are not mounted,
 * so evict the audience root fields (across all args) to force a fresh fetch
 * when each market is next opened. The current market is refreshed by the
 * mutation's own refetchQueries.
 *
 * Not the same rule as the neighbouring `useEvictMarketAudienceTextCache` —
 * that one covers cross-market question text and so evicts `listCategoriesV2`
 * rather than `fieldworkAudienceV2`. The overlap is coincidental; do not merge
 * them.
 */
export const evictAudienceCaches = (cache: ApolloCache<unknown>): void => {
  cache.evict({ id: 'ROOT_QUERY', fieldName: 'draftAudienceV2' })
  cache.evict({ id: 'ROOT_QUERY', fieldName: 'customCriteriaV2' })
  cache.evict({ id: 'ROOT_QUERY', fieldName: 'fieldworkAudienceV2' })
  cache.gc()
}
